"use strict";
let loggingFunction = console.error.bind(console);
module.exports = (truthy, message) => {
    if (!truthy) {
        loggingFunction(message);
    }
    return truthy;
};
module.exports.setErrorLoggingFunction = λ => {
    loggingFunction = λ;
};
module.exports.getErrorLoggingFunction = () => {
    return loggingFunction;
};
